
import { isOdd, isEven } from 'vessel/utils'

export default {
  name: 'VsTableRow',
  inject: ['table'],
  provide() {
    return {
      tableRow: this
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isFirst() {
      return this.index === 0
    },
    isLast() {
      return this.index === this.table.data.length - 1
    },
    isOdd() {
      return isOdd(this.index)
    },
    isEven() {
      return isEven(this.index)
    },
    hasStripe() {
      return this.isOdd && this.table.stripe
    }
  }
}
